import { useState, useEffect, useContext } from "react";
import { UserServiceContext } from "../services/user/userService";
import Loader from "../components/Loader";
import CustomAlert from "../components/CustomAlert";
import { paginationComponentOptions } from "../utils/constants";
import ReactDataTable from "react-data-table-component";
import { IconPdf } from "@tabler/icons-react";
import Cookies from "js-cookie";
import axios from "axios";

const Invoices = () => {
  const { getInvoices, loading } = useContext(UserServiceContext);
  const [invoices, setInvoices] = useState([]);

  const [formData, setFormData] = useState({
    dateFrom: "",
    dateTo: "",
  });

  const keyDown = (e) => {
    e.preventDefault();
    return false;
  };

  const formatDate = (isoString) => {
    if (isoString) {
      const date = new Date(isoString);
      return date.toISOString().split("T")[0];
    }
  };

  const fetchInvoices = async (data) => {
    const response = await getInvoices(data);

    if (response && response.data.success) {
      setInvoices(response.data.invoices);
    }
  };

  const handleDateChange = (e) => {
    const { id, value } = e.target;
    const selectedDate = new Date(value).toISOString();
    setFormData({
      ...formData,
      [id]: selectedDate,
    });

    fetchInvoices(formData);
  };

  useEffect(() => {
    const today = new Date();
    const oneMothAgo = new Date(today);
    oneMothAgo.setMonth(today.getMonth() - 1);

    const initialForm = {
      dateFrom: oneMothAgo.toISOString(),
      dateTo: today.toISOString(),
    };

    setFormData({
      ...formData,
      dateFrom: oneMothAgo.toISOString(),
      dateTo: today.toISOString(),
    });

    fetchInvoices(initialForm);
  }, []);

  const handlePdfClick = async (pdfLink) => {
    const token = Cookies.get("Token");
    if (!token) return;

    axios
      .get(pdfLink, {
        headers: {
          token: `${token}`,
        },
        responseType: "blob", // important for binary files like PDFs
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        //const link = document.createElement("a");
        //link.href = window.URL.createObjectURL(blob);
        //link.download = "file.pdf";
        //link.click();
        const fileURL = window.URL.createObjectURL(blob);
        window.open(fileURL, "_blank");
      })
      .catch((error) => {
        console.error("Error downloading PDF:", error);
      });

    // const response = await fetch(pdfLink, {
    //   method: "GET",
    //   headers: {
    //     token: token,
    //     Accept: "application/pdf",
    //   },
    // });

    // if (!response.ok) {
    //   console.error("Failed to fetch PDF");
    //   return;
    // }

    // const blob = await response.blob();
    // const url = window.URL.createObjectURL(new Blob([blob]));

    // window.open(url, "_blank");
  };

  const columns = [
    { name: "ინვოისის ნომერი", selector: (row) => row.name },

    { name: "სულ თანხა", selector: (row) => row.amount },
    { name: "სტატუსი", selector: (row) => row.status },
    {
      name: "თარიღი",
      selector: (row) => {
        const date = new Date(row.rd);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
    },
    {
      name: "PDF",
      cell: (row) => (
        <div
          //href={row.pdfLink}
          //target="_blank"
          //rel="noopener noreferrer"
          className="text-blue-500 hover:text-blue-700"
          onClick={() => handlePdfClick(row.pdfLink)}
        >
          <IconPdf size={20} />
        </div>
      ),
      width: "60px",
      style: { cursor: "pointer" },
    },
  ];

  return (
    <>
      {loading && <Loader />}
      <div className="md:px-6 sm:px-3 pt-4">
        <div className="container-fluid">
          <div className="flex  gap-4 border border-border-color rounded-s-md mr-[-1px] py-[6px] px-[12px] bg-body-color mt-20">
            <div className="flex flex-direction-row justify-between w-full">
              <div className="flex flex-direction-row">
                <div>
                  <label htmlFor="dateFrom" className="form-label">
                    თარიღიდან :
                  </label>
                  <input
                    type="date"
                    lang="ka-GE"
                    id="dateFrom"
                    className="form-control"
                    onKeyDown={keyDown}
                    value={formatDate(formData.dateFrom)}
                    onChange={(e) => handleDateChange(e)}
                  />
                </div>
                <div className="ml-10">
                  <label htmlFor="dateTo" className="form-label">
                    თარიღამდე :
                  </label>
                  <input
                    type="date"
                    id="dateTo"
                    className="form-control"
                    onKeyDown={keyDown}
                    value={formatDate(formData.dateTo)}
                    onChange={(e) => handleDateChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="react-data-table mt-20">
            <ReactDataTable
              //onRowClicked={handleRowClick}
              columns={columns}
              pagination
              striped
              data={invoices}
              paginationComponentOptions={paginationComponentOptions}
              noDataComponent={
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "gray",
                  }}
                >
                  ინვოისები არ მოიძებნა
                </div>
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Invoices;
